import { assert, deepCloneWith, isRecord } from '@takeshape/util';
import { CURRENT_OPEN_API_TRANSFORM_VERSION } from "../../constants.js";
import { updateAuthentication } from "../../util/authentication.js";
import { endpointWithPath, getHealthCheck } from "../../util/health.js";
import { getInitialData } from "../../util/initial-data.js";
import { BaseServiceProvider } from "../common/base-service-provider.js";
export class OlyslagerServiceProvider extends BaseServiceProvider {
    serviceType = 'openapi';
    introspectionType = 'openapi';
    getConfig(formData) {
        const config = {
            id: formData.id ?? this.createId(formData),
            title: formData.title ?? this.title,
            provider: this.name,
            serviceType: this.serviceType,
            authenticationType: 'bearer',
            namespace: formData.namespace,
            options: {
                endpoint: 'https://api.olyslager.com/rest/',
                spec: 'https://raw.githubusercontent.com/takeshape/openapi-specs/refs/heads/main/specs/olyslager/v1.0.json',
                transformVersion: CURRENT_OPEN_API_TRANSFORM_VERSION,
                headers: {
                    'x-oly-dataset': formData.dataset
                }
            }
        };
        return updateAuthentication(config, formData, {
            type: 'bearer',
            header: 'x-oly-subscription',
            prefix: ''
        });
    }
    isServiceConfig(serviceConfig) {
        return super.isServiceConfig(serviceConfig);
    }
    getHealthCheck(serviceConfig) {
        return getHealthCheck({
            checkName: 'ping',
            endpoint: endpointWithPath('products'),
            requestMethod: 'GET',
            requestSearchParams: {
                language: 'en'
            },
            healthyResponseStatusCode: 200
        })(serviceConfig);
    }
    specTransform(spec) {
        assert('openapi' in spec, 'Olyslager uses an OpenAPI v3 spec makes sure you are using the correct url');
        return deepCloneWith(spec, (value, key, parent, clone) => {
            // These give funky names
            if (key === 'operationId') {
                return '';
            }
            // Two headers are set from the service config
            if (key === 'parameters' && Array.isArray(value)) {
                return value
                    .filter((item) => !(isRecord(item) && (item.name === 'x-oly-subscription' || item.name === 'x-oly-dataset')))
                    .map((item, i) => clone(item, i, value));
            }
        });
    }
    getInitialData(serviceConfig) {
        const initialData = getInitialData({
            serviceType: this.serviceType,
            name: this.name,
            getFormSchema: this.getFormSchema.bind(this)
        }, serviceConfig);
        // Relocate this value for editing
        initialData.dataset = serviceConfig?.options?.headers?.['x-oly-dataset'];
        return initialData;
    }
}
